import { requestEncrypt, returnDecrypt } from "./fuse.auth";
import $jsonp from "./jsonp";
const userAgent = navigator.userAgent.toLowerCase();

const isMobile = /mobile/i.test(userAgent);

const isAndroid = /android/i.test(userAgent);

const isIOS = /iphone|ipad|ipod|macintosh/i.test(userAgent);

const isWX = /MicroMessenger/i.test(userAgent);
const getSession = key => JSON.parse(sessionStorage.getItem(key) || "{}");
const saveSession = (key, value) =>
  sessionStorage.setItem(key, JSON.stringify(value));
const removeSession = key => sessionStorage.removeItem(key);
const checkPhone = number => {
  if (/^1[3456789]\d{9}$/.test(number)) {
    return true;
  }
};
const checkEmail = email => {
  /* eslint-disable */
  if (
    /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/.test(
      email
    )
  ) {
    return true;
  }
};
const checkIdCare = id => {
  if (/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(id)) {
    return true;
  }
};
const checkName = name => {
  if (/^[\u4e00-\u9fa5]{2,4}$/.test(name)) {
    return true;
  }
};
const inject = (container, src, tag = "iframe") => {
  let context = document.createElement(tag);
  context.id = "i-" + new Date().getTime();
  if (tag === "link") {
    context.href = src;
    context.rel = "stylesheet";
  } else {
    context.src = src;
  }
  document.querySelectorAll(container)[0].appendChild(context);
  return new Promise((resolve, reject) => {
    context.onload = () => resolve(context);
  });
};
// 弹框
const showMsg = (txt = "", Autoclose = true) => {
  let msg = document.createElement("div");
  msg.innerHTML = `
        <div className="msg" style="
        position: fixed;
        left:50%;
        top:50%;
        margin-left:-2.3rem;
        font-size: 0.28rem;
        padding: 0.2rem 0.3rem;
        border-radius: 0.08rem;
        background: rgba(0, 0, 0, 0.8);
        line-height: 1.5;
        text-align: center;
        width: 4rem;
        color: #fff;
        word-break:break-all;
        z-index:9999999";
        id="show_tip">
            ${txt}
        </div>
    `;
  // 添加弹框在body里
  document.body.appendChild(msg);
  if (Autoclose) {
    //DOM removeChild （）删除弹框
    const timerAutoclose = setTimeout(() => {
      document.body.removeChild(msg);
      clearTimeout(timerAutoclose);
    }, 1500);
  } else {
    //找到指定id的父节点
    document.getElementById("show_tip").parentNode.onclick = function() {
      document.body.removeChild(msg);
    };
  }
};
// 获取url？后的字符串并转成对象
const getURLparams = () => {
  let url = location.search; // 获取url中"?"符后的字串
  let theRequest = {};
  if (url.indexOf("?") !== -1) {
    let str = url.substr(1);
    let strs = str.split("&");
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
    }
  }
  return theRequest;
};
const payAjax = (...arg) => {
  let payload = [...arg];
  if (!payload[2]) payload[2] = {};
  // 建立筛选
  payload[2].filter = function(obj) {
    let { ct, ac, p, ts, js } = obj;
    let newObj = {
      ...obj
    };
    delete newObj.ac;
    delete newObj.ct;
    // console.log(`${arg[0]}(input)`, arg[1]);
    if (js) {
      return {
        ct,
        ...(ac
          ? {
              ac
            }
          : {}),
        p: p,
        ts: ts,
        js: js
      };
    } else {
      return {
        ct,
        ...(ac
          ? {
              ac
            }
          : {}),
        p: p,
        ts: ts
      };
    }
  };
  return new Promise((resolve, reject) => {
    $jsonp(
      (payload[2].domain =
        payload[2].domain || configUrl.__gamepayDomain.get()),
      payload[2].filter(payload[1])
    )
      .then(res => {
        if (res.data && res.data.d) {
          res.data = JSON.parse(
            returnDecrypt(res.data.d, String(res.data.ts)).d
          );
        }
        // console.log("payAjax", res.data);
        // if (res.code !== 0) {
        //   // ... 错误处理
        //   showMsg(res.msg)
        // }
        // console.log(`${arg[0]}(res)`, res);
        resolve(res);
      })
      .catch(e => {
        // console.log("FN._sdk_ajax error:", e);
      });
  });
};
const sdkAjax = (...arg) => {
  let payload = [...arg];
  // 加密KEY生成
  let KEY = String(new Date().getTime()).substr(0, 10);
  if (!payload[2]) payload[2] = {};
  // 建立筛选
  payload[2].filter = function(obj) {
    let { ct, ac } = obj;
    let newObj = {
      ...obj
    };
    delete newObj.ac;
    delete newObj.ct;

    // console.log(`${arg[0]}(input)`, arg[1]);
    // console.log(`payload[2].domain`, payload[2].domain);

    return {
      ct,
      // ac,
      ...(ac
        ? {
            ac
          }
        : {}),
      p: requestEncrypt(JSON.stringify(newObj), KEY).e,
      ts: KEY,
      js: 1
    };
  };
  return new Promise((resolve, reject) => {
    $jsonp(
      (payload[2].domain =
        payload[2].domain || configUrl.__gameapiDomain.get()),
      payload[2].filter(payload[1])
    )
      .then(res => {
        if (res.data && res.data.d) {
          res.data = JSON.parse(
            returnDecrypt(res.data.d, String(res.data.ts)).d
          );
        }
        if (res.code !== 0) {
          // ... 错误处理
          showMsg(res.msg);
        }
        // console.log(`${arg[0]}(res)`, res);
        resolve(res);
      })
      .catch(e => {
        // console.log("FN._sdk_ajax error:", e);
      });
  });
};
const fuseSdkAjax = (...arg) => {
  let payload = [...arg];
  // 加密KEY生成
  let KEY = String(new Date().getTime()).substr(0, 10);
  if (!payload[2]) payload[2] = {};
  // 建立筛选
  payload[2].filter = function(obj) {
    let { ct, ac } = obj;
    let newObj = {
      ...obj,
      is_jsdk: 1
    };
    delete newObj.ac;
    delete newObj.ct;

    // console.log(`${arg[0]}(input)`, arg[1]);

    return {
      ct,
      ac,
      p: requestEncrypt(JSON.stringify(newObj), KEY).e,
      ts: KEY,
      is_jsdk: 1
    };
  };
  return new Promise((resolve, reject) => {
    // console.log(payload[2].domain);
    $jsonp(payload[2].domain, payload[2].filter(payload[1]))
      .then(res => {
        if (res.data && res.data.d) {
          res.data = JSON.parse(
            returnDecrypt(res.data.d, String(res.data.ts)).d
          );
        }
        if (res.code !== 0) {
          // ... 错误处理
          if ([...arg][1].isShowToast !== 0) {
            showMsg(res.msg);
          }
        }
        // console.log(`${arg[0]}(res)`, res);
        resolve(res);
      })
      .catch(e => {
        // console.log("FN._fuse_sdk_ajax error:", e);
      });
  });
};

// 时间戳转年月日时分秒
const formatDateTime = timeStamp => {
  var date = new Date();
  date.setTime(timeStamp * 1000);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  var d = date.getDate();
  d = d < 10 ? "0" + d : d;
  var h = date.getHours();
  h = h < 10 ? "0" + h : h;
  var minute = date.getMinutes();
  var second = date.getSeconds();
  minute = minute < 10 ? "0" + minute : minute;
  second = second < 10 ? "0" + second : second;
  return isIOS
    ? y + "/" + m + "/" + d + " " + h + ":" + minute + ":" + second
    : y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
};


export default {
  showMsg,
  isMobile,
  isAndroid,
  isIOS,
  isWX,
  getSession,
  saveSession,
  removeSession,
  checkPhone,
  checkEmail,
  checkIdCare,
  checkName,
  sdkAjax,
  fuseSdkAjax,
  payAjax,
  getLocal: key => JSON.parse(localStorage.getItem(key) || "{}"),
  saveLocal: (key, value) => localStorage.setItem(key, JSON.stringify(value)),
  removeLocal: key => localStorage.removeItem(key),
  getURLparams,
  formatDateTime,
  OS: {
    isMobile,
    isAndroid,
    isIOS
  }
};



// WEBPACK FOOTER //
// ./src/common/fn.js